"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
var _exportNames = {
  CommonShareDialog: true,
  CommonShareSocial: true,
  CommonShareURL: true
};
exports.CommonShareURL = exports.CommonShareSocial = exports.CommonShareDialog = void 0;

var _commonShareDialog = _interopRequireDefault(require("./components/common-share-dialog"));

exports.CommonShareDialog = _commonShareDialog["default"];

var _commonShareSocial = _interopRequireDefault(require("./components/common-share-social"));

exports.CommonShareSocial = _commonShareSocial["default"];

var _commonShareUrl = _interopRequireDefault(require("./components/common-share-url"));

exports.CommonShareURL = _commonShareUrl["default"];

var _commonShareDialog2 = require("./components/common-share-dialog.utils");

Object.keys(_commonShareDialog2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _commonShareDialog2[key]) return;
  exports[key] = _commonShareDialog2[key];
});